import { Injectable } from '@angular/core';
import { AsmComponentService } from '@spartacus/asm/components';

@Injectable({
  providedIn: 'root',
})
export class CustomAsmComponentService extends AsmComponentService {
}
